const {
    REACT_APP_BUILD_ENV,
    REACT_APP_FILESTACK_KEY,
    REACT_APP_FILESTACK_CONTAINER,
    REACT_APP_FILESTACK_REGION
 } = process.env;

const devConfig = {
    key: REACT_APP_FILESTACK_KEY,
    container: REACT_APP_FILESTACK_CONTAINER,
    region: REACT_APP_FILESTACK_REGION
};

const prodConfig = window.APP_ENV && window.APP_ENV.fileStack;

export default REACT_APP_BUILD_ENV === 'dev' ? devConfig : prodConfig;
